const actions = {
  SET_STATE: 'tenant/SET_STATE',
  LOAD_STATE: 'tenant/LOAD_STATE',
  GET_STATE: 'tenant/GET_STATE',
  SET_TENANT: 'tenant/SET_TENANT',
}
export default actions
